const normalizeEmail = user => String(user?.email || '').trim().toLowerCase();
export const canViewSmsTransactions = user => ['isaac.kalenda@yahoo.fr','marcelmusaas05@gmail.com'].includes(normalizeEmail(user));
export const canViewSalaryMenu = user => normalizeEmail(user) === 'isaac.kalenda@yahoo.fr';
export const filterVisibleMenu = (sections,user) => sections.map(section=>({...section,items:section.items.filter(item=>
 (item.path !== '/sms-transactions' || canViewSmsTransactions(user)) &&
 (item.path !== '/salary-payments' || canViewSalaryMenu(user))
)})).filter(section=>section.items.length);
